/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Clients
// ====================================================

export interface Clients_clients {
  __typename: "Client";
  id: string;
  name: string;
}

export interface Clients {
  clients: Clients_clients[];
}
